// extracted by mini-css-extract-plugin
export default {"container":"HeaderScrollHandler_container__6L2an","subTitle":"HeaderScrollHandler_subTitle__M0PIn"};